import ucfirst from '@seafront/ucfirst';

const ucfirstEachWord = (text) => {
  const fragments = text.split(' ');
  return fragments.map(f => ucfirst(f)).join(' ');
};

export default ucfirstEachWord;
